module.exports = __webpack_public_path__ + "static/media/fly0222.164910e7.webp";